<div class="menu-barra-branca" [ngClass]="{ escondeMenu: !isPrimeiroAcesso }">
  <div class="ui-fluid">
    <div class="w-g">
      <div class="col-lg-12 col-xs-12 menu-topo">
        <div class="col-md-6 col-sm-6 col-lg-3 d-flex">
          <fa-icon
            class="icon-menu"
            [icon]="iconMenu"
            (click)="btMenuChange()"
          ></fa-icon>
          <img *ngIf="iconeLogo" [src]="iconeLogo" class="logo" />
        </div>

        <div class="col-lg-12 col-md-6 col-sm-6 col-lg-9 menu-config">
          <div class="guarda-icones">
            <div
              class="userImg"
              *ngIf="imageToShow; else noImageFound"
              [ngStyle]="{
                'background-image':
                  'url(' +
                  imageToShow['changingThisBreaksApplicationSecurity'] +
                  ')'
              }"
            ></div>
            <ul
              class="hide"
              style="display: flex; gap: 10px; padding-right: 50px"
            >
              <li>
                <b>TESTE DE PERMISSAO</b>
              </li>

              <li (click)="admin()">admin</li>

              <li (click)="user()">user</li>

              <li (click)="teste1()">teste1</li>

              <li (click)="teste2()">teste2</li>

              <li (click)="getEmpresas()">empresas</li>

              <li (click)="getCedentes()">cedentes</li>

              <li (click)="getSacados()">sacados</li>
            </ul>

            <ng-template #noImageFound>
              <i
                class="menu-icon fa fa-user-circle-o"
                style="padding-right: 5px"
              ></i>
            </ng-template>

            <span class="texto">{{ usuario?.firstName }}</span>

            <fa-icon
              [icon]="iconeMenuUser"
              class="iconSvg iconeMenuUser"
              [matMenuTriggerFor]="menu"
            ></fa-icon>

            <mat-menu #menu="matMenu">
              <div class="menuConfigUser">
                <div class="header">
                  <div class="titulo">
                    <span class="nome">{{ usuario?.firstName }}</span>
                    <span class="email">{{ usuario?.email }}</span>
                  </div>
                </div>
                <div class="subheader">
                  <span class="nomePerfil">{{ getPerfil() }} </span>
                </div>

                <div class="separador"></div>

                <ul>
                  <li
                    *ngIf="
                      !isPrimeiroAcesso && visao && visao !== 'sacado' && false
                    "
                    class="info"
                    (click)="alterarSenha()"
                  >
                    <fa-icon [icon]="iconeAlterar" class="iconSvg"></fa-icon>
                    <em><span class="fonte-li1">Alterar senha </span></em>
                  </li>
                  <li
                    *ngIf="!isPrimeiroAcesso && visao !== 'sacado' && false"
                    class="info"
                    (click)="editarPerfil()"
                  >
                    <fa-icon [icon]="iconeEditar" class="iconSvg"></fa-icon>
                    <em><span class="fonte-li1">Editar perfil </span></em>
                  </li>
                  <li
                    (click)="trocarVisao()"
                    *ngIf="!isPrimeiroAcesso && menuCedenteSacado"
                    class="info"
                  >
                    <fa-icon [icon]="iconeVisao" class="iconSvg"></fa-icon>
                    <em><span class="fonte-li1">Trocar visão </span></em>
                  </li>
                  <li class="info" (click)="logout()">
                    <fa-icon [icon]="iconeSair" class="iconSvg"></fa-icon>
                    <em><span class="fonte-li2">Sair</span></em>
                  </li>
                </ul>
              </div>
            </mat-menu>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>